import React, { useEffect, useState } from 'react';

interface LoaderProps {
  onComplete: () => void;
}

export const Loader: React.FC<LoaderProps> = ({ onComplete }) => {
  const [fade, setFade] = useState(false);

  useEffect(() => {
    // Keep loader active for 2.5 seconds to showcase the animation
    const timer = setTimeout(() => {
      setFade(true);
      // Wait for fade-out transition to complete (500ms)
      const exitTimer = setTimeout(() => {
        onComplete();
      }, 500);
      return () => clearTimeout(exitTimer);
    }, 2500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  // CSS Square nesting structure matching the template
  const NestedSquares = () => (
    <div className="loader-square">
      <div className="loader-square">
        <div className="loader-square">
          <div className="loader-square">
            <div className="loader-square">
              <div className="loader-square" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={`fixed inset-0 z-50 flex flex-col items-center justify-center bg-cyber-black transition-opacity duration-500 ease-in-out ${
        fade ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <div className="relative w-32 h-32 scale-75 md:scale-100">
        <div className="loader-container">
          <div className="loader-top">
            <NestedSquares />
          </div>
          <div className="loader-bottom">
            <NestedSquares />
          </div>
          <div className="loader-left">
            <NestedSquares />
          </div>
          <div className="loader-right">
            <NestedSquares />
          </div>
        </div>
      </div>

      <div className="absolute bottom-20 flex flex-col items-center space-y-2">
        <h2 className="text-xl font-mono tracking-[0.2em] text-cyber-green font-bold uppercase animate-pulse">
          Initializing System
        </h2>
        <p className="text-xs font-mono text-cyber-blue opacity-80">
          ALOK_SINGH // PORTFOLIO_V2.0
        </p>
      </div>
    </div>
  );
};
